import ShopProvider from "./ShopProvider";
import camelize from "camelize";

export default class Api {
  domain: string;

  constructor(domain: string) {
    this.domain = domain;
  }

  sendVerifyCode = (phoneNumber: string, userId: string, optinMethod: string) => {
    return fetch(this.getUrl("/api/public/users.sendVerifyCode"), {
      method: "post",
      body: JSON.stringify({
        user_id: userId,
        phone_number: phoneNumber,
        domain: this.domain,
        optin_method: optinMethod,
      }),
      headers: { "Content-Type": "application/json" }
    });
  };

  submitVerifyCode = (
    code: string,
    phoneNumber: string,
    acceptMarketing: boolean,
    userId: string,
    optinMethod: string
  ) => {
    return fetch(this.getUrl("/api/public/users.createFromCheckout"), {
      method: "post",
      body: JSON.stringify({
        user_id: userId,
        code,
        phone_number: phoneNumber,
        accept_marketing: acceptMarketing,
        domain: this.domain,
        optin_method: optinMethod,
      }),
      headers: { "Content-Type": "application/json" }
    });
  };

  getEligibleForOptIn = () => {
    const [token, token_type] = this.getToken();
    let url;
    if (token_type === "order") {
      url = this.getUrl(
        "/api/public/users.isEligibleForOptInByShopifyOrderToken"
      );
    } else {
      url = this.getUrl(
        "/api/public/users.isEligibleForOptInByShopifyCheckoutToken"
      );
    }
    return fetch(url, {
      method: "post",
      body: JSON.stringify({
        token: token,
        domain: this.domain
      }),
      headers: { "Content-Type": "application/json" }
    })
      .then(async r => {
        if (r.status === 400) {
          const json = await r.json();
          const detail = json.error && json.error.detail;
          detail && console.log("Error received: " + detail);
          throw new Error("Received a 400 from the server.");
        } else if (r.status !== 200 && r.status != 201) {
          throw new Error(`Received a ${r.status} from the server.`);
        }
        return r;
      })
      .then(this.parseJSON)
      .then((response: EligibilityResponse) => ({
        isEligible: response.is_eligible,
        userId: response.user_id,
        shop: camelize(response.shop.data.attributes),
        phone: response.phone
      }));
  };

  getToken(): string[] {
    const m = window.location.pathname.match(/\/(checkouts|orders)\/(\w+)/);
    if (!m) {
      throw new Error("URL is not in expected format");
    }
    const token_type = m[1].slice(0, -1);
    const token = m[2];
    return [token, token_type];
  }

  getUrl(url: string) {
    return process.env["REACT_APP_VELOCITY_URL"] + url;
  }

  parseJSON(response: Response) {
    return response.json();
  }
}

interface IsNotEligibleResponse {
  is_eligible: false;
}

interface Shop {
  data: {
    attributes: {
      name: string;
      color: string;
      lightColor: string;
      optinSettings: {
        discountText: string;
        discountUrl: string;
        modal: {
          body: string;
          title: string;
        };
        page: {
          body: string;
          title: string;
        };
        termsOfService: string;
      };
      tos: string;
      tosUrl: string;
      policyUrl: string;
      optInPreference: string;
    }
  }
}

interface IsEligibleResponse {
  is_eligible: true;
  user_id: string;
  shop: Shop;
  phone: string;
}

type EligibilityResponse = IsNotEligibleResponse & IsEligibleResponse;

// const checkResponse = (response: Response) => {
//   if (response.status !== 200 && response.status !== 201) {
//     const err = `Received a ${response.status} from server`;
//     throw new Error(err);
//   }

//   return response;
// };

// Love u fetch standard
// const appendQueryParams = (
//   url: string,
//   params: { [key: string]: string }
// ): string => {
//   const u = new URL(url);
//   Object.keys(params).forEach(key => u.searchParams.append(key, params[key]));
//   return u.toString();
// };
